
import { Grid } from "@material-ui/core";
import styled from "styled-components";

export const LeftAlignedGrid = styled(Grid)`&& {
    font-family: Work Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0em;
    text-align:left;
    margin-bottom:8px;
  }
`;
export const RightAlignedGrid = styled(Grid)`&& {
    text-align:right;
    margin-bottom:8px;
    font-family: Work Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0em;
  }
`;
export const DateText = styled.div`
  font-family: Work Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
`;
